import {
  DrawerHeader,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  Box,
} from '@chakra-ui/react';
import Editor from '@monaco-editor/react';
import React, { useMemo } from 'react';
import { format } from 'sql-formatter';

import { Typography } from 'packages/common-frontend/components/Typography';
import { colors } from '~/packages/common-frontend/colors';
import { lightTheme } from '~/packages/creditAgreements/ui/CreditAgreementFullArtifact/edit/MonacoEditor/ui/common';

export const ViewSqlDrawer = (props: {
  onClose: () => void;
  sqlQuery: string;
  queryName: string;
}) => {
  const { onClose, sqlQuery, queryName } = props;

  const formattedQuery = useMemo(
    () =>
      format(sqlQuery, {
        language: 'trino', // athena uses trino & presto
      }),
    [sqlQuery],
  );
  return (
    <Drawer onClose={onClose} isOpen size="xl">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerHeader>
          <Typography variant="section-title" trim>
            {queryName}
          </Typography>
        </DrawerHeader>
        <DrawerBody>
          <Box
            resize="vertical"
            overflowY="visible"
            h="800px"
            minH="400px"
            width="100%"
            borderWidth="1px"
            borderColor={colors.gray[200]}
            borderRadius="8px"
            p="24px 24px 24px 0"
            backgroundColor="white"
            className="editor-container"
          >
            <Editor
              language="sql"
              value={formattedQuery}
              onChange={() => {}}
              theme={lightTheme}
              options={{
                readOnly: true,
                lineNumbers: 'on',
                overviewRulerBorder: true,
                overviewRulerLanes: 3,
                renderLineHighlight: 'all',
                scrollbar: { vertical: 'auto' },
                minimap: { enabled: false },
                fixedOverflowWidgets: false,
                suggest: {
                  preview: false,
                  showInlineDetails: true,
                },
              }}
            />
          </Box>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};
